import {gql} from 'apollo-angular';
import {ProfessionPreviewFragment} from "./fragments/ProfessionPreview";
import {ContactGalleryFragment} from "./fragments/ContactGallery";
import {ImageFragment} from "./fragments/Image";
import {MediaGalleryFragment} from "./fragments/MediaGallery";

export const GET_BOINSTITUTION_PROFILE_BY_ID = gql`
  query GetBoInstitutionProfileById($id: Int, $uuid: String) {
    bopartnerProfile(id: $id, uuid: $uuid) {
      id
      name
      uuid
      description
      quizUrl
      logoStyle
      certificateInformation
      headerPicture {
        ...imageFields
      }
      boPartnerProfilePicture {
        ...imageFields
      }
      locations {
        name
        address {
          street
          number
          addressCity {
            name
            addressDistrict {
              name
            }
          }
          addressLatLon {
            lat
            lon
          }
        }
      }
      jobs {
        ...professionPreviewFields,
      }
      documents {
        galleryItems {
          id
          contentType
          document {
            id
            filePath
            name
          }
        }
      }
      url
      contactGallery {
        ...contactGalleryFields
      }
      mediaGallery {
        ...mediaGalleryFields
      }
      offers {
        offerType
        name
      }
      profileLink {
        entries {
          linkType
          linkValue
        }
      }
      relatedBoPartners {
        id
        uuid
        name
        boPartnerProfilePicture {
          ...imageFields
        }
        jobs {
          id
          name
          interestFields {
            id
          }
        }
        locations {
          name
          address {
            street
            addressCity {
              name
              addressDistrict {
                name
              }
            }
            addressLatLon {
              lat
              lon
            }
          }
        }
      }
    }
  }
  ${ProfessionPreviewFragment}
  ${ContactGalleryFragment}
  ${ImageFragment}
  ${MediaGalleryFragment}
`;
